import { AccountApplicationCategoryDto, AccountApplicationDocumentDto, AccountApplicationDto } from 'src/dtos';
import {
  AccountApplication,
  AccountApplicationCategory,
  AccountApplicationCategoryName,
  AccountApplicationDocument,
  AccountApplicationDocumentType,
  EntityAccountType,
} from 'src/models';

export const mapAcountApplicationDocumentDtoToModel = (
  dto: AccountApplicationDocumentDto,
): AccountApplicationDocument => {
  return {
    id: dto.id,
    originalFilename: dto.originalFilename,
    type: new AccountApplicationDocumentType(dto.type),
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

export const mapAccountApplicationCategoryDtoToModel = ({
  category,
  entityAccountType,
}: {
  category: AccountApplicationCategoryDto;
  entityAccountType?: EntityAccountType;
}): AccountApplicationCategory => {
  return {
    name: new AccountApplicationCategoryName(category.name, entityAccountType),
    isResolved: category.isResolved,
    requestedDocuments: category.requestedDocuments.map(doc => new AccountApplicationDocumentType(doc)),
    totalRequestedDocuments: category.totalRequestedDocuments,
    uploadedDocuments: category.uploadedDocuments.map(mapAcountApplicationDocumentDtoToModel),
    adminNote: category.adminNote,
  };
};

export const mapAccountApplicationDtoToModel = (dto: AccountApplicationDto): AccountApplication => {
  const entityAccountType = dto.account.entityAccountType
    ? new EntityAccountType(dto.account.entityAccountType)
    : undefined;

  return {
    id: dto.id,
    account: {
      id: dto.account.id,
      entityAccountType,
    },
    categories: dto.categories.map(category =>
      mapAccountApplicationCategoryDtoToModel({ category, entityAccountType }),
    ),
    uploadedDocuments: dto.uploadedDocuments.map(mapAcountApplicationDocumentDtoToModel),
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
